var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.376312,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.667 10.8763H11.667C11.3908 10.8763 11.167 11.1002 11.167 11.3763V21.3763C11.167 21.6525 11.3908 21.8763 11.667 21.8763H21.667C21.9431 21.8763 22.167 21.6525 22.167 21.3763V11.3763C22.167 11.1002 21.9431 10.8763 21.667 10.8763ZM11.667 9.37631C10.5624 9.37631 9.66699 10.2717 9.66699 11.3763V21.3763C9.66699 22.4809 10.5624 23.3763 11.667 23.3763H21.667C22.7716 23.3763 23.667 22.4809 23.667 21.3763V11.3763C23.667 10.2717 22.7716 9.37631 21.667 9.37631H11.667ZM20.667 19.2335L18.167 16.3763L15.6914 19.2056L14.167 17.3763L12.667 19.1763V20.3763H20.667V19.2335ZM15.167 16.3763C15.9954 16.3763 16.667 15.7047 16.667 14.8763C16.667 14.0479 15.9954 13.3763 15.167 13.3763C14.3386 13.3763 13.667 14.0479 13.667 14.8763C13.667 15.7047 14.3386 16.3763 15.167 16.3763Z",
    fill: "#737278"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/noimage.7a06da03c41091feb259a1d2b34b93c4.svg";
export { ForwardRef as ReactComponent };